module.exports = "/assets/420a18b561f7009ddab81da2689aae87.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/TZ.png
// module id = 2994
// module chunks = 0